import React from 'react'
import shopbanner from '../../images/shop.png'
import {Row, Container, Col} from 'react-bootstrap'
import Productapi from './Productapi'

export default function Shop() {
  return (
    <>
  <div className="breadcrumb-banner" >
    <img src={shopbanner} className="img-fluid" alt="Shop"/>
  <div className="container-bread">
       <h1 className="text-white">
        Shop
        </h1>
    </div>
  </div>

  <div className="shopsection pt-5 pb-5">
   <Container >
    <Row>
    <Col md={12}>
    
    <Productapi/>
    </Col>



    </Row>
    </Container>
  </div>

   
    </>
  )
}
